import { type MutationHookOptions, useMutation } from "@apollo/client";
import { UpdateContentMutation } from "../graphql/mutations";
import type {
  UpdateContentMutationType,
  UpdateContentMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useUpdateContentMutation = (
  options?: MutationHookOptions<
    UpdateContentMutationType,
    UpdateContentMutationVariablesType
  >
) => {
  return useMutation<
    UpdateContentMutationType,
    UpdateContentMutationVariablesType
  >(UpdateContentMutation, options);
};
